import Access01 from "./access";
import Activity from "./activity";
import BiometricAccess from "./biometric-access";
import Fingerprint from "./fingerprint";
import Link from "./link";
import Link2 from "./link-2";
import LogIn from "./log-in";
import LogOut from "./log-out";
import Login01 from "./login-01";
import Login02 from "./login-02";
import Login03 from "./login-03";
import LoginCircle01 from "./login-circle-01";
import LoginCircle02 from "./login-circle-02";
import LoginSquare01 from "./login-square-01";
import LoginSquare02 from "./login-square-02";
import ScanEye from "./scan-eye";
import ScanFace from "./scan-face";
import ScanQrCode from "./scan-qr-code";
import ScanSearch from "./scan-search";
import UniversalAccess from "./universal-access";

export * from "./activity";
export * from "./link";
export * from "./link-2";
export * from "./scan-eye";
export * from "./scan-face";
export * from "./log-in";
export * from "./log-out";
export * from "./fingerprint";
export * from "./scan-search";
export * from "./scan-qr-code";
export * from "./access";
export * from "./login-01";
export * from "./login-02";
export * from "./login-03";
export * from "./login-circle-01";
export * from "./login-circle-02";
export * from "./login-square-01";
export * from "./login-square-02";
export * from "./biometric-access";
export * from "./universal-access";

export const Access = {
  Activity,
  Link,
  Link2,
  ScanEye,
  ScanFace,
  LogIn,
  LogOut,
  Fingerprint,
  ScanSearch,
  ScanQrCode,
  Access01,
  Login01,
  Login02,
  Login03,
  LoginCircle01,
  LoginCircle02,
  LoginSquare01,
  LoginSquare02,
  BiometricAccess,
  UniversalAccess,
};
